import * as React from 'react';

function SvgInformationCircle(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", d: "M12 2C6.485 2 2 6.486 2 12c0 5.513 4.486 9.999 10 9.999 5.513 0 9.999-4.486 9.999-10 0-5.513-4.486-9.999-10-9.999zm0 4.1a1.3 1.3 0 110 2.6 1.3 1.3 0 010-2.6zm2.4 11.3H10a.8.8 0 110-1.6h1.4v-4.4h-.8a.8.8 0 110-1.6h1.6a.8.8 0 01.8.8v5.2h1.4a.8.8 0 010 1.6z" })));
}

export default SvgInformationCircle;
